import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';
import { PairChallenge } from '@rocksoft/settings-sdk';

@Component({
  selector: 'era-pairing-challenge-ui',
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './pairing-challenge.component.html',
})
export class PairingChallengeComponent {
  public readonly challenge = input.required<PairChallenge>();
  readonly enroll = output<PairChallenge>();

  public continue() {
    this.enroll.emit(this.challenge());
  }
}
